import { Fragment } from 'react';

/**
 * Renders a translation whose value carries newlines as the line breaks the live page wrote as
 * `<br>`.
 *
 * The alternative is HTML inside the string table and `dangerouslySetInnerHTML` around it, which is
 * what the page this replaces does — and what makes a translator's stray tag a rendering bug rather
 * than a typo.
 */
export function TextLines({ text }: { text: string }) {
    return (
        <>
            {text.split('\n').map((line, index) => (
                <Fragment key={line + String(index)}>
                    {index > 0 && <br />}
                    {line}
                </Fragment>
            ))}
        </>
    );
}
